import { memo } from "react";

import { cn } from "~/lib/cn";

/** Decorative SVG background for hero sections. */
export const HeroBackground = memo(({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1360"
      height="784"
      fill="none"
      viewBox="0 0 1360 784"
      preserveAspectRatio="xMidYMin slice"
      className={cn(className)}
    >
      <g
        clipPath="url(#hero_backround__svg_c)"
        mask="url(#hero_backround__svg_mask)"
      >
        <rect width="1360" height="784" rx="16" fill="#fff" fillOpacity=".8" />
        <g stroke="#eedaff" className="hero-background">
          <circle cx="680.5" cy="764.5" r="381" />
          <circle cx="680" cy="764" r="525.5" />
          <circle cx="680.5" cy="764.5" r="708" />
        </g>
        <circle
          cx="680"
          cy="764"
          r="536"
          fill="url(#hero_backround__svg_radialGradient)"
          opacity="0.6"
        />
      </g>
      <defs>
        <radialGradient
          id="hero_backround__svg_radialGradient"
          cx="50%"
          cy="50%"
          r="50%"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0%" stopColor="#eedaff" stopOpacity="1" />
          <stop offset="70%" stopColor="#eedaff" stopOpacity="0.8" />
          <stop offset="85%" stopColor="#eedaff" stopOpacity="0.4" />
          <stop offset="100%" stopColor="#eedaff" stopOpacity="0" />
        </radialGradient>
        <linearGradient
          id="hero_backround__svg_linearGradient"
          x1="680"
          y1="0"
          x2="680"
          y2="784"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.75" stopColor="white" stopOpacity="1" />
          <stop offset="0.95" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <mask id="hero_backround__svg_mask">
          <rect
            width="1360"
            height="784"
            fill="url(#hero_backround__svg_linearGradient)"
          />
        </mask>
        <clipPath id="hero_backround__svg_c">
          <rect width="1360" height="784" rx="16" fill="#fff" fillOpacity="1" />
        </clipPath>
      </defs>
    </svg>
  );
});

HeroBackground.displayName = "HeroBackground";
